import { fixedUi, fixedUiTpl } from './fixedUi';

/** 设计器界面文案：中文源码保持原文，非中文走 fixedUi / designerUiEn。 */
export function designerText(text, options) {
  return fixedUi(text, options);
}

export function designerTextTpl(text, ...values) {
  return fixedUiTpl(text, ...values);
}

/** 配置项 label 本地化（value 不变）。 */
export function localizeDesignerOptions(options) {
  return (options || []).map((opt) => (
    opt?.label ? { ...opt, label: designerText(opt.label) } : opt
  ));
}
